<template>
  <div>
    <p class="mb-1">
      <strong>GESTIONES JURÍDICA - DEMANDA {{ demand.number }}</strong>
    </p>
    <hr class="p-0 mt-0" />

    <form class="box-typical" v-if="role_id != 6">
      <textarea
        type="text"
        class="write-something"
        rows="3"
        :placeholder="`- Ingresa tu gestión`"
        v-model="management.management"
      ></textarea>

      <div class="box-typical-footer">
        <div class="tbl">
          <div class="tbl-row">
            <b-row>

              <b-col>
                <b-form-group>
                  <date-picker
                    id="txtFecha"
                    name="date"
                    v-model="management.date"
                    :config="options"
                    placeholder="Fecha"
                  ></date-picker>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group>
                  <b-form-select v-model="management.type">
                    <template slot="first">
                      <option :value="null" disabled>-- Tipo Gestión --</option>
                    </template>

                    <option
                      v-for="item in lstTypeTask"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group>
                  <b-form-file
                    :browse-text="'Buscar'"
                    v-model="files"
                    :state="Boolean(files)"
                    v-on:change="onImageFile"
                    placeholder="Archivos ..."
                    drop-placeholder="Archivos ..."
                    multiple
                  ></b-form-file>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group>
                  <b-form-select v-model="management.privacy">
                    <option
                      v-for="item in lstPrivacy"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col sm="1">
                <b-form-group>
                  <button
                    type="button"
                    class="btn btn-success"
                    @click="saveManagement()"
                  >
                    Enviar
                  </button>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </form>

    <section class="proj-page-section comments">
      <section
        class="without"
        v-if="!lstManagements.length > 0"
        style="margin-top: 0px"
      >
        <div class="row">
          <figure class="text-center">
            <img src="img/sin_gestion.png" alt width="210px" />
          </figure>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <h1>Oops!</h1>
            <h4>
              No hay gestiones
              <br />en esta demanda.
            </h4>
          </div>
        </div>
      </section>

      <div class="comments" v-if="READ && lstManagements.length > 0">
        <section
          class="box-typical comment box-typical-custom"
          v-for="item in lstManagements"
          :key="item.id"
        >
          <div class="row">
            <div class="col-sm-2 mr-0">
              <div class="row">
                <div class="col-md-12 text-center">
                  <strong>
                    <p class="mb-2">CREADA POR</p>
                  </strong>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-center">
                  <img
                    v-if="item.user_image === null"
                    src="img/avatars/avatar-2-64.png"
                    class="rounded-circle"
                  />
                  <img
                    v-else
                    :src="item.user_image"
                    class="rounded-circle img-gestion"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-center mt-2">
                  <p>{{ item.user_name }}</p>
                </div>
              </div>
            </div>
            <div class="col-sm-10">
              <div class="row">
                <div class="col-sm-9"></div>
                <div class="col-sm-3 text-right mb-2 pr-0">
                  <b-button
                    size="sm"
                    variant="info"
                    class="mr-1"
                    title="Editar"
                    @click="editManagement(item)"
                    v-if="UPDATE"
                  >
                    <i class="fa fa-edit"></i>
                  </b-button>

                  <b-button
                    size="sm"
                    variant="danger"
                    title="Eliminar"
                    @click="deleteManagement(item)"
                    v-if="DELETE"
                  >
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <p class="mb-1">
                    <strong># RADICADO</strong>
                  </p>
                  <p>{{ item.number_filed }}</p>
                </div>

                <div class="col">
                  <p class="mb-1">
                    <strong>FECHA</strong>
                  </p>
                  <p>{{ formatDateDescription(item.date, false) }}</p>
                </div>

                <div class="col">
                  <p class="mb-1">
                    <strong>TIPO</strong>
                  </p>
                  <p>{{ item.type_name }}</p>
                </div>

                <div class="col">
                  <p class="mb-1">
                    <strong>PRIVACIDAD</strong>
                  </p>
                  <p>{{ item.privacy_name }}</p>
                </div>
                <div class="col">
                  <p class="mb-1">
                    <strong>ESTADO</strong>
                  </p>
                  <p class="text-danger">{{ item.status_name }}</p>
                </div>
              </div>
              <hr />

              <div class="row" v-if="item.management">
                <div class="col">
                  <p class="mb-1">
                    <strong>COMENTARIOS</strong>
                  </p>
                  <p class="text-justify">{{ item.management }}</p>
                </div>
              </div>

              <div class="row row-footer" v-if="role_id != 6">
                <div class="w100 text-right mr-2 mt-2">
                  <p>
                    <i class="fa fa-clock-o"></i>
                    Creada el &nbsp;{{ formatDateDescription(item.created_at, true) }}
                    <i class="fa fa-clock-o ml-2"></i>
                    Actualizada el &nbsp;{{ formatDateDescription(item.updated_at, true) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <pagination
          class="mb-0"
          :data="laravelData"
          @pagination-change-page="getManagements"
          :limit="limit"
          :show-disabled="showDisabled"
          :size="size"
          :align="align"
        >
          <span slot="prev-nav">Anterior</span>
          <span slot="next-nav">Siguiente</span>
        </pagination>
      </div>
    </section>

    <!-- MODAL PARA LAS GESTIONES -->
    <div class="modal fade" id="dlgManagement">
      <div class="modal-dialog modal-dialog-centered modal-success modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">GESTIÓN</h4>
            <button type="button" class="close" @click="closeTaskManagement()">
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form
              @submit.prevent="updateManagement()"
              method="put"
              class="box-typical"
              v-if="management_edit.id"
            >
              <textarea
                type="text"
                class="write-something"
                rows="3"
                :placeholder="`- Ingresa tu gestión`"
                v-model="management_edit.management"
              ></textarea>

              <div class="box-typical-footer">
                <div class="tbl">
                  <div class="tbl-row">
                    <b-row>
                      <b-col>
                        <b-form-group>
                          <date-picker
                            name="date"
                            v-model="management_edit.date"
                            :config="options"
                            placeholder="Fecha"
                          ></date-picker>
                        </b-form-group>
                      </b-col>

                      <b-col>
                        <b-form-group>
                          <b-form-select v-model="management_edit.type">
                            <template slot="first">
                              <option :value="null" disabled>
                                -- Tipo Gestión --
                              </option>
                            </template>

                            <option
                              v-for="item in lstTypeTask"
                              :key="item.id"
                              :value="item.id"
                            >
                              {{ item.name }}
                            </option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>

                      <b-col>
                        <b-form-group>
                          <b-form-file
                            :browse-text="'Buscar'"
                            v-model="files"
                            :state="Boolean(files)"
                            v-on:change="onImageFile"
                            placeholder="Archivos ..."
                            drop-placeholder="Archivos ..."
                            multiple
                          ></b-form-file>
                        </b-form-group>
                      </b-col>

                      <b-col>
                        <b-form-group>
                          <b-form-select v-model="management_edit.privacy">
                            <option
                              v-for="item in lstPrivacy"
                              :key="item.id"
                              :value="item.id"
                            >
                              {{ item.name }}
                            </option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>

                      <b-col sm="1">
                        <b-form-group>
                          <button type="submit" class="btn btn-success">
                            Enviar
                          </button>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </form>
            <!--.box-typical-->
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA LAS GESTIONES -->
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "DemandManagement",
  props: {
    demand: {
      type: Object,
      default: {},
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      minDate: moment(String(new Date())).format("YYYY-MM-DD"),
      options: {
        // https://momentjs.com/docs/#/displaying/
        format: "DD/MM/YYYY h:mm A",
        useCurrent: true,
        showClear: true,
        showClose: true,
        //minDate: moment().subtract(2, "d"),
        maxDate: moment(),
      },
      lstManagements: [],
      lstTypeTask: [],
      lstPrivacy: [],
      management: {
        date: null,
        type: null,
        demand_id: null,
        management: null,
        privacy: 52, // PUBLICA
      },
      management_edit: {},
      files: null,
      isEdit: false,
      pagination: {},
      disabled: false,
      datos: [],
      errores: [],
      disabledForm: false,
      debtor_id: null,

      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      // VARIABLES PARA LA PAGINACIÓN
      laravelData: {},
      limit: 5,
      showDisabled: true,
      size: "small",
      align: "right",
      title: "CREAR",
    };
  },
  created() {
    this.enabledActions();
    this.getManagements();

    // 21: TIPO DE GESTIONES - DEUDOR JURÍDICO
    this.$http.get(`${this.$urlApi}parameters/21?token=${this.token}`).then(
      (response) => {
        this.lstTypeTask = response.data.data;
      },
      (error) => {
        console.log(error);
        hideLoader();
      }
    );

    // 14:  PRIVACIDAD
    this.$http.get(`${this.$urlApi}parameters/14?token=${this.token}`).then(
      (response) => {
        this.lstPrivacy = response.data.data;
      },
      (error) => {
        console.log(error);
      }
    );
  },

  methods: {
    getManagements: function (page = 1) {
      showLoader();

      this.lstManagements = [];
      this.laravelData = {};

      // ARMAR LA URL CON LA PAGINACIÓN
      let url = `${this.$urlApi}demandmanagements/demand/${this.demand.id}?token=${this.token}&page=${page}`;

      this.$http
        .get(url, this.auth, {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            console.log(response);

            this.lstManagements = response.data.data.data;
            this.laravelData = response.data.data;
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },

    formatDate(value) {
      if(this.role_id == '6') return moment(String(value)).format("MM/YYYY");
      else return moment(String(value)).format("DD/MM/YYYY");
    },

    formatDateDescription(value, showHour) {
      if (!value) return "";
      else {
        if (value == "--") return value;
        else {
          var d = moment(value).format("DD");
          var m = moment(value).format("MMM");
          var a = moment(value).format("YYYY");
          var h = moment(value).format("hh:mm A");
          if(showHour) return d + " de " + m + " " + a + " " + h;
          else return d + " de " + m + " " + a;
        }
      }
    },

    validateTimeDaily(management) {
      if (management.date !== null && management.minutes !== null) {
        let auth = localStorage.getItem("auth");
        auth = JSON.parse(auth);

        var dateString = management.date.toString();
        var momentObj = moment(dateString, "DD/MM/YYYY h:mm A");
        var momentString = momentObj.format("YYYY-MM-DD");

        this.$http
          .get(
            `${this.$urlApi}taskmanagements/minutes/${auth[0].id}/${momentString}?token=${this.token}`
          )
          .then(
            (response) => {
              console.log(
                "Total minutos hoy => " + response.data.data.total_minutos
              );
              let totalMinutos =
                parseInt(response.data.data.total_minutos) +
                parseInt(management.minutes);

              if (totalMinutos > this.$maxMinutes) {
                this.$swal({
                  title: "Advertencia",
                  text: "Ya superó su cuota laboral del día! =>" + momentString,
                  type: "warning",
                  showCancelButton: false,
                  confirmButtonText: "Aceptar",
                });

                management.minutes = null;
                return false;
              }
            },
            (error) => {
              console.log(error);
            }
          );
      }
    },
    saveManagement() {
      showLoader();

      this.management.demand_id = this.demand.id;
      let formData = new FormData();
      formData.append("data", JSON.stringify(this.management));

      if(this.files && this.files.length > 0) {
        for (let i = 0; i < this.files.length; i++) {
          formData.append("documents[]", this.files[i]);
        }
      }


      this.$http
        .post(
          `${this.$urlApi}demandmanagements?token=${this.token}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        )
        .then(function (response) {
          // console.log(response)

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Gestión guardada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.management = {
                date: null,
                type: null,
                demand_id: null,
                management: null,
                privacy: null,
              };
              this.lstFiles = [];
              this.getManagements();
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    deleteManagement(management) {
      // VALIDAR SI ES UN COMERCIAL Y SI PUEDE ELIMINAR
      if (!this.role_id == 1) {
        var auth = localStorage.getItem("auth");
        auth = JSON.parse(auth);
        var user_id = auth[0].id;

        if (management.user_id != user_id) {
          this.$swal({
            title: "Advertencia",
            text:
              "La gestión no se puede eliminar, fue creada por otro usuario!",
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }

        // VERIFICAR EL TIEMPO TRANSCURRIDO
        var fechaGestion = moment(
          management._created_at,
          "YYYY-MM-DD HH:mm:ss"
        );
        var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
        var dias = fechaActual.diff(fechaGestion, "days");
        var minutos = fechaActual.diff(fechaGestion, "m");

        if (dias > 0 || minutos > 10) {
          this.$swal({
            title: "Oops...",
            text:
              "La gestión ya superó los 10 minutos para ser eliminada, contacte con el administrador.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }
      }

      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar la gestión ?",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(
              `${this.$urlApi}demandmanagements/${management.id}?token=${this.token}`,
              { headers: { "Content-Type": "application/json" } }
            )
            .then(function (response) {
              //console.log(response)
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Gestión eliminada correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getManagements();
                }
              });
            })
            .catch((error) => {
              console.log(error);
              hideLoader();
            });
        }
      });
    },
    editManagement(management) {
      this.files = [];

      // VALIDAR SI ES UN COMERCIAL Y SI PUEDE EDITAR
      if (!this.role_id == 1) {
        // VERIFICAR EL TIEMPO TRANSCURRIDO
        var fechaGestion = moment(
          management._created_at,
          "YYYY-MM-DD HH:mm:ss"
        );
        var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
        var dias = fechaActual.diff(fechaGestion, "days");
        var minutos = fechaActual.diff(fechaGestion, "m");

        if (dias > 0 || minutos > 10) {
          this.$swal({
            title: "Oops...",
            text:
              "La gestión ya superó los 10 minutos para ser editada, contacte con el administrador.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }
      }

      this.errores = [];
      $("#dlgManagement").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.management_edit = Object.assign({}, management);
      $("#dlgManagement").modal("show");
    },
    updateManagement() {
      showLoader();

      let formData = new FormData();
      formData.append("data", JSON.stringify(this.management_edit));

      for (let i = 0; i < this.files.length; i++) {
        formData.append("documents[]", this.files[i]);
      }

      formData.append("_method", "PUT");

      this.$http
        .post(
          `${this.$urlApi}demandmanagements/${this.management_edit.id}?token=${this.token}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        )
        .then(function (response) {
          //console.log(response)
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Gestión actualizada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.management_edit = {};
              this.lstFiles = [];
              this.getManagements();
              $("#dlgManagement").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    closeTaskManagement() {
      this.management_edit = {
        date: null,
        minutes: null,
        type: null,
        task_id: null,
        management: null,
        customer_id: null,
        user_id: null,
        status_id: null,
      };
      $("#dlgManagement").modal("hide");
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    onImageFile(e) {
      let lstFiles = e.target.files;
      this.files = [];
      if (!lstFiles.length) return false;
      for (let i = 0; i < lstFiles.length; i++) {
        this.files.push(lstFiles[i]);
      }
    },

    enabledActions() {
      // var auth = localStorage.getItem("auth");
      // auth = JSON.parse(auth);
      // this.isCustomer = auth[0].customer_id != null ? true : false;

      // console.log("role_id =>" + this.role_id);

      switch (this.role_id) {
        case "1": // ADIMISTRADOR
          this.CREATE = true;
          this.READ = true;
          this.UPDATE = true;
          this.DELETE = true;
          break;

        case "2": // COMERCIAL
        case "7": // GERENTE COMERCIAL
          this.CREATE = true;
          this.READ = true;
          this.UPDATE = true;
          this.DELETE = true;
          break;

        case "4": // PREJURIDICO
        case "8": // GERENTE PREJURIDICO
          this.CREATE = true;
          this.READ = true;
          this.UPDATE = false;
          this.DELETE = false;
          break;

        case "5": // JURIDICO
        case "9": // GERENTE JURIDICO
          this.CREATE = true;
          this.READ = true;
          this.UPDATE = true;
          this.DELETE = true;
          break;

        case "6": // CLIENTE
          this.CREATE = false;
          this.READ = true;
          this.UPDATE = false;
          this.DELETE = false;
          break;

        default:
          // OTRO ROL
          this.CREATE = false;
          this.READ = false;
          this.UPDATE = false;
          this.DELETE = false;
          break;
      }
    },
  },
};
</script>
